import React from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { darkModeAtom, toggleDarkModeAtom } from '../Services/store/atoms';
import { BsSunFill, BsMoonFill } from 'react-icons/bs';

const SideBarDarkModeToggle = () => {
  const [darkMode] = useAtom(darkModeAtom);
  const toggleDarkMode = useSetAtom(toggleDarkModeAtom);

  return (
    <button
      id="theme-toggle"
      onClick={() => { console.log('Toggle clicked, current darkMode:', darkMode); toggleDarkMode(); }}
      aria-label="Toggle Dark Mode"
      role="switch"
      aria-checked={!!darkMode}
      className={`relative inline-flex items-center shrink-0 h-[31px] w-[51px] rounded-full p-[2px] transition-colors duration-300 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500/50 ${darkMode ? 'bg-rose-500' : 'bg-gray-200'}`}
    >
      <span className="sr-only">Toggle dark mode</span>
      <span
        className={`w-[27px] h-[27px] transform bg-white rounded-full transition-transform duration-300 flex items-center justify-center shadow-[0_3px_8px_rgba(0,0,0,.15),0_1px_1px_rgba(0,0,0,.16)] ${
          darkMode ? 'translate-x-5' : 'translate-x-0'
        }`}
      >
        {darkMode ? (
          <BsMoonFill className="text-rose-500 text-xs" />
        ) : (
          <BsSunFill className="text-amber-500 text-xs" />
        )}
      </span>
    </button>
  );
};

export default SideBarDarkModeToggle;
